import DepartmentDetailContainer from "./DepartmentDetailContainer";
export default DepartmentDetailContainer;
